import { z } from 'zod';

// Coarse per-article category assigned by the AI tagger (gpt-4o-mini). The order
// is the display order of sections in the "topics" feed layout.
export const AI_CATEGORIES = [
  'domaci',
  'zahranici',
  'ekonomika',
  'tech',
  'veda',
  'sport',
  'kultura',
  'auta',
  'gaming',
  'hobby',
  'pocasi',
  'jine',
] as const;
export const aiCategory = z.enum(AI_CATEGORIES);
export type AiCategory = z.infer<typeof aiCategory>;

/** Map a raw db value to a known category; unknown/NULL fall into the catch-all. */
export function toAiCategory(value: string | null | undefined): AiCategory {
  return (AI_CATEGORIES as readonly string[]).includes(value ?? '') ? (value as AiCategory) : 'jine';
}

export const feedLayout = z.enum(['reels', 'list', 'grid', 'topics']);
export type FeedLayout = z.infer<typeof feedLayout>;
